
function MainNavigation(){

    let toggle = document.querySelector('.header-main__toggle');
    let body = document.body;
    let close = document.querySelector('.svg-close');
    let hasChildren = document.querySelectorAll('.menu-item-has-children');

    toggle.addEventListener('click', function(e){
        e = e || window.event;
        e.returnValue = false;
        if(e.preventDefault) e.preventDefault();
        body.classList.add('main-nav-open');
    });

    close.addEventListener('click', function(e){
        e = e || window.event;
        e.returnValue = false;
        if(e.preventDefault) e.preventDefault();
        body.classList.remove('main-nav-open');
    });

    hasChildren.forEach( el => {
        el.addEventListener('click', () => {
            hasChildren.forEach( element => {
                let subnav = element.querySelector('ul');
                if(element !== el)
                    $(subnav).slideUp();
            });
            let subnav = el.querySelector('ul');
            $(subnav).slideToggle();
        });
    });

    let searchToggle = document.querySelector('.header-main__search');
    let searchContainer = document.querySelector('.dgwt-wcas-search-wrapp');
    let searchSuggestions = document.querySelector('.dgwt-wcas-suggestions-wrapp');

    document.addEventListener('click', function(event) {
        let isClickInsideElement = searchContainer.contains(event.target);
        let isClickSearchToggle = searchToggle.contains(event.target);
        let isClickSearchSuggestions = null;
        if( searchSuggestions ) {
            isClickSearchSuggestions = searchSuggestions.contains(event.target);
        }
        if (!isClickInsideElement && !isClickSearchToggle && !isClickSearchSuggestions && document.body.classList.contains('main-search--open') === true ) {
            body.classList.remove('main-search--open');
        }
    });

    searchToggle.addEventListener('click', function(e){
        e = e || window.event;
        e.returnValue = false;
        if(e.preventDefault) e.preventDefault();
        body.classList.add('main-search--open');
    });

}